module.exports = {"440507001":"金霞街道","440507003":"珠池街道","440507004":"新津街道","440507005":"鸥汀街道","440507008":"龙祥街道","440507100":"外砂镇","440507101":"新溪镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440507.json
// module id = 1978
// module chunks = 0